import * as Constants from '../constants';

const initialState = {
  isLoading: false,
  error: null,
  emails: [],
  submitSaveSuccess: null
};

export default function(state = initialState, action) {
  switch (action.type) {
    case Constants.REQUEST_NOTIFICATION_EMAIL:
      return { ...state, isLoading: true, error: null };
    case Constants.RECEIVE_NOTIFICATION_EMAIL:
      if (action.error) {
        console.log(`Receive Activation Error  ${action.error}`);
        return {
          ...state,
          isLoading: false,
          error: action.error
        };
      }
      return {
        ...state,
        isLoading: false,
        emails: action.response.notificationSubscribers,
        error: null
      };
    case Constants.REQUEST_UPDATE_NOTIFICATION_EMAIL:
      return {
        ...state,
        isLoading: true,
        error: null,
        submitSaveSuccess: null
      };
    case Constants.RECEIVE_UPDATE_NOTIFICATION_EMAIL:
      if (action.error) {
        console.log(`Receive Notification Subscribers Error  ${action.error}`);
        return {
          ...state,
          isLoading: false,
          error: action.error,
          submitSaveSuccess: null
        };
      }
      return {
        ...state,
        isLoading: false,
        emails: action.response.notificationSubscribers,
        error: null,
        submitSaveSuccess: true
      };
    default:
      return state;
  }
}
